import classNames from 'classnames';
import { bool, node } from 'prop-types';

import './row.scss';

function AuthFormRow({ children, center }) {
  return (
    <div
      className={classNames(
        'AuthFormRow alk-flex',
        center && 'AuthFormRow--center',
      )}
    >
      {children}
    </div>
  );
}

AuthFormRow.propTypes = {
  children: node,
  center: bool,
};

export default AuthFormRow;
